import { Directive } from '@angular/core';

@Directive({
  selector: '[uniLabelSuffix]',
})
export class UniLabelSuffixDirective {}
